import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import SmartImage from 'dpl/components/SmartImage';
import Icon from 'dpl/common/components/Icon';
import Logo from 'dpl/components/Logo';
import MiniOverlayCloseButton from 'dpl/common/mini_overlay_modal/components/MiniOverlayModalCloseButton';

import { trackBuyerApplicationQuestionView } from '../utils';
import CoverMessage from './CoverMessage';

const IMAGE_DIMS = isLessThanBreakpoint('md')
  ? { width: '88px', height: '88px' }
  : { width: '140px', height: '140px' };

export default function IntroOverlay({
  breederName,
  breederSlug,
  programName,
  photoUrl,
  onStartClick,
  onCloseClick,
  buyerApplicationData,
  fixedNav,
  adoptableBreedName
}) {
  const { cityState } = useSelector(({ server }) => server);

  useEffect(() => {
    trackBuyerApplicationQuestionView('Apply for Puppy Welcome Breeder', {
      programName,
      breederSlug
    });
  }, []);

  return (
    <div className="AdoptionApplicationIntroOverlay tc min-vh-100 flex flex-column">
      <div className="Header__logo pt4 purple center">
        <Logo />
      </div>
      <div className="flex-auto flex justify-center items-center">
        <div className="mb4 mb16-lg mw-100">
          <MiniOverlayCloseButton onCloseClick={onCloseClick} />
        </div>

        <div className="AdoptionApplicationIntroOverlay__container center ph4 pb20">
          <p
            className="f4 fw-medium f6-md mb6"
            data-test-id="intro-buyer-application-header"
          >
            Get in touch with {programName}
          </p>
          <div className="mb2 mb4-lg">
            <SmartImage
              src={photoUrl}
              className="br-100"
              loadingClass="bg-light-gray"
              crop
              {...IMAGE_DIMS}
            />
          </div>
          <p className="fw-medium f4">{breederName}</p>
          {cityState && <p className="mb1">{cityState}</p>}
          <p className="mb8">{adoptableBreedName}</p>
          <CoverMessage
            programName={programName}
            breederName={breederName}
            buyerApplicationData={buyerApplicationData}
          />
          <div
            className={classnames({
              'fixed bottom-0 left-0 right-0 box-shadow-2 pv3 ph2 bg-white z-1':
                fixedNav
            })}
          >
            <button
              type="button"
              data-test-id="start-buyer-application-button"
              onClick={onStartClick}
              className="button button--primary button--large pv3 inline-flex fw-medium w-100 w-auto-ns align-items-center"
            >
              <span className="flex-auto">Answer a few questions</span>
              <Icon className="ml2-md" name="lined-arrow-right" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

IntroOverlay.propTypes = {
  breederName: PropTypes.string,
  breederSlug: PropTypes.string,
  programName: PropTypes.string,
  photoUrl: PropTypes.string,
  onStartClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  buyerApplicationData: PropTypes.object.isRequired,
  fixedNav: PropTypes.bool,
  adoptableBreedName: PropTypes.string
};

IntroOverlay.defaultProps = {
  breederName: null,
  breederSlug: null,
  programName: null,
  photoUrl: null,
  fixedNav: false,
  adoptableBreedName: null
};
